"use strict";

import http from "@/http";

const BASE_NAME = "/obligations";

const list = async () => {
  const response = await http.get(`${BASE_NAME}`);
  return response.data;
};

const create = async data => {
  const response = await http.post(`${BASE_NAME}`, data);
  return response.data;
};

const edit = async obligation => {
  const response = await http.put(`${BASE_NAME}/${obligation._id}`, obligation);
  return response.data;
};

const remove = async id => {
  const response = await http.delete(`${BASE_NAME}/${id}`);
  return response.data;
};

// "Propagar etiquetas": etiquetas declaradas y no declaradas en las copias.
const getTagPropagation = async id => {
  const response = await http.get(`${BASE_NAME}/${id}/tag-propagation`);
  return response.data;
};

// Quien tiene la etiqueta y quien no, separado por nombre de obligacion.
const getTagPropagationDetail = async (id, tagId) => {
  const response = await http.get(`${BASE_NAME}/${id}/tag-propagation/${tagId}/detail`);
  return response.data;
};

// action: "assign" o "remove". Devuelve el estado actualizado.
const propagateTag = async (id, action, tagId) => {
  const response = await http.put(`${BASE_NAME}/${id}/tag-propagation/${action}`, { tag: tagId });
  return response.data;
};

const getObligationTypes = async () => {
  const response = await http.get("/lookup-values/obligations/types");
  return response.data;
};

const getDueDateTypes = async () => {
  const response = await http.get("/lookup-values/obligations/dueDateTypes");
  return response.data;
};

export default {
  list,
  create,
  edit,
  remove,
  getTagPropagation,
  getTagPropagationDetail,
  propagateTag,
  getObligationTypes,
  getDueDateTypes
};
